/** The clock format the "+" Add Staff dialog's add and move analytics events report times in, so the two compare. */
export const QUICK_ADD_ANALYTICS_TIME_FORMAT = "HH:mm";

/** Analytics/error `source` for the "+" Add Staff dialog's add and move paths. */
export const QUICK_ADD_SOURCE = "quick_add_nurse_dialog";
